module.exports = __webpack_public_path__ + "static/img/20210719171854.3198844d.png";